// extracted by mini-css-extract-plugin
module.exports = {"pillBold":"Pill_pillBold__2ue5N"};